import { Directive, ElementRef, HostListener, Input, AfterViewInit, inject } from '@angular/core';

@Directive({ selector: '[appExcludeInputPattern]' })
export class ExcludeInputPatternDirective implements AfterViewInit {
  private element = inject(ElementRef);

  @Input() public excludedPattern;

  compiledExcludedPattern: RegExp;

  ngAfterViewInit() {
    this.compiledExcludedPattern = new RegExp(this.excludedPattern, 'g');
  }

  @HostListener('keypress', ['$event'])
  onInputChange(event) {
    if (event.key.match(this.compiledExcludedPattern)) {
      event.preventDefault();
    }
  }
}
